import { TENANT } from '../../constant'

export type Tenant = keyof typeof TENANT

export function isAthena(tenantId: string): tenantId is Tenant {
  return tenantId === TENANT.DEVOTED
}

export function isConcertoCare(tenantId: string): tenantId is Tenant {
  return tenantId === TENANT.CONCERTOCARE
}

export function isOptum(tenantId: string): tenantId is Tenant {
  return tenantId === TENANT.OPTUM
}
